<template>
  <div>
    <v-dialog v-model="message.status">
      <v-alert
        class="mx-auto my-12"
        max-width="374"
        v-model="message.status"
        dismissible
        prominent
        shaped
        :type="message.color"
      >{{ message.text }}
      </v-alert>
    </v-dialog>
    <v-card
      class="mx-auto my-12"
      max-width="900"
    >
      <v-card-title>مدیریت نقش ها</v-card-title>
      <v-card-text>
        <v-row
          align="center"
          class="mx-0"
        >
          <v-data-table
            :headers="headers"
            :items="roles"
            hide-default-footer
            class="elevation-1 mt-3"
            style="width: 100%"
          >
            <template v-slot:top>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h6">آیا مطمئن هستید که این نقش حذف شود؟
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">خیر</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">بله</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                elevation="2"
                class="ma-1"
                tile
                outlined
                :to="'/role/permission/'+item.name"
              >
                مدیریت مجوزها
                <v-icon
                  small
                  right
                >
                  {{ mdiKey }}
                </v-icon>
              </v-btn>
              <v-btn
                color="primary"
                elevation="2"
                class="ma-1"
                tile
                outlined
                :to="'/role/route/'+item.name"
              >
                مدیریت مسیرها
                <v-icon
                  small
                  right
                >
                  {{ mdiRoutes }}
                </v-icon>
              </v-btn>
              <v-btn
                color="warning"
                elevation="2"
                class="ma-1"
                tile
                outlined
                :to="'/role/assign/'+item.name"
              >
                تنظیم نقش برای کاربران
                <v-icon
                  small
                  right
                >
                  {{ mdiAccount }}
                </v-icon>
              </v-btn>

              <v-btn
                color="error"
                elevation="2"
                class="ma-1"
                icon
                @click="deleteItem(item)"
              >
                <v-icon
                  small
                >
                  {{ mdiDelete }}
                </v-icon>
              </v-btn>

            </template>
          </v-data-table>
          <v-text-field
            label="نام نقش"
            v-model="name"
          ></v-text-field>
          <v-btn
            color="primary"
            elevation="3"
            rounded
            x-large
            block
            @click="addRole"
          >
            افزودن نقش
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mdiPencil, mdiDelete, mdiKey, mdiAccount, mdiRoutes} from '@mdi/js'
import axios from "@axios";
import router from "@/router";
import baseConfig from "../../../baseConfig";

export default {
  name: 'Role',
  beforeCreate() {
    if (localStorage.getItem("accessToken") === "undefined" || localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === "null" || localStorage.getItem("accessToken") === null || localStorage.getItem("accessToken") === "") {
      router.push('/login')
    }
  },
  async mounted() {
    await axios.get(baseConfig.baseUrl+'roles/getRoles').then(r => {
      this.roles = r.data.data
    })
  },
  data: () => ({
    mdiPencil,
    mdiDelete,
    mdiKey,
    mdiAccount,
    mdiRoutes,
    dialog: false,
    name: '',
    message: {
      status: false,
      text: "success operation",
      color: "success"
    },
    dialogDelete: false,
    headers: [
      {
        text: 'نام نقش', value: 'name',
      },
      {
        text: '', value: 'actions', sortable: false,
      },
    ],
    roles: [],
  }),

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  methods: {
    async addRole() {
      await axios.post(baseConfig.baseUrl+'roles/addRole', {
        name: this.name
      }).then(r => {
        if (r.data.status === "success")
          this.roles = r.data.data
        this.message = {
          status: true,
          text: "success operation",
          color: "success"
        }
      })
    },
    editItem(item) {
    },

    deleteItem(item) {
      this.editedItem = item
      this.dialogDelete = true
    },

    async deleteItemConfirm() {
      await axios.delete(baseConfig.baseUrl+'roles/deleteRole/' + this.editedItem.id).then(r => {
        if (r.data.status === "success")
          this.roles = r.data.data
        this.message = {
          status: true,
          text: "success operation",
          color: r.data.status === "success" ? "success" : "error"
        }
        setTimeout(() => {
          this.message.status = false
        }, 30000)
      })
      this.closeDelete()
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = null
        this.editedIndex = -1
      })
    },
  },
}
</script>
<style scoped>

</style>
